import { DropdownItemProps } from '../../third-party-ui/Dropdown';

export const sortDropdownItemsTextComp = (a: DropdownItemProps, b: DropdownItemProps): number => {
    const aText: string = a.text as string;
    const bText: string = b.text as string;
    return aText.localeCompare(bText);
};